import { ThemedText } from "@/components/themed-text";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/constants";
import { BrandColors } from "@/constants/theme";
import { useAuth } from "@/contexts/auth-context";
import { useCreateRequestStore } from "@/stores/use-create-request-store";
import Ionicons from "@react-native-vector-icons/ionicons";
import { useLocalSearchParams } from "expo-router";
import React, { useEffect } from "react";
import { Linking, StyleSheet, TouchableOpacity, View } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

export default function CheckoutSuccessScreen() {
  const { theme } = useAuth();
  const { session_id } = useLocalSearchParams<{ session_id?: string }>();
  const { resetForm } = useCreateRequestStore();

  useEffect(() => {
    resetForm();
  }, [resetForm]);

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.background }]}
    >
      <View style={styles.content}>
        <View style={styles.iconContainer}>
          <Ionicons
            name="checkmark-circle"
            size={80}
            color={BrandColors.primary}
          />
        </View>
        <ThemedText type="title" style={styles.title}>
          Payment Successful
        </ThemedText>
        <ThemedText type="default" style={styles.message}>
          Thank you for your payment. Your booking is being processed and you
          will receive a confirmation email shortly.
        </ThemedText>
        {session_id ? (
          <ThemedText type="small" style={styles.reference}>
            Reference: {session_id}
          </ThemedText>
        ) : null}
        <ThemedText type="defaultSemiBold" style={styles.downloadPrompt}>
          Download the app to track your booking
        </ThemedText>
        <View style={styles.storeButtons}>
          <TouchableOpacity
            style={styles.appStoreButton}
            onPress={() => Linking.openURL(APP_STORE_URL)}
            accessibilityRole="link"
            accessibilityLabel="Download on the App Store"
          >
            <Ionicons name="logo-apple" size={22} color="#0f172a" />
            <ThemedText
              lightColor="#0f172a"
              darkColor="#0f172a"
              type="defaultSemiBold"
            >
              App Store
            </ThemedText>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.playStoreButton}
            onPress={() => Linking.openURL(PLAY_STORE_URL)}
            accessibilityRole="link"
            accessibilityLabel="Get it on Google Play"
          >
            <Ionicons name="logo-google-playstore" size={22} color="#ffffff" />
            <ThemedText
              lightColor="#ffffff"
              darkColor="#ffffff"
              type="defaultSemiBold"
            >
              Google Play
            </ThemedText>
          </TouchableOpacity>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 24,
    gap: 16,
  },
  iconContainer: {
    marginBottom: 8,
  },
  title: {
    textAlign: "center",
  },
  message: {
    textAlign: "center",
    color: "#94a3b8",
    lineHeight: 24,
  },
  reference: {
    color: "#64748b",
    marginBottom: 8,
  },
  downloadPrompt: {
    textAlign: "center",
    marginTop: 8,
  },
  storeButtons: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "center",
    gap: 12,
    marginTop: 8,
  },
  appStoreButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    backgroundColor: "#ffffff",
    borderRadius: 16,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderWidth: 1,
    borderColor: "#e2e8f0",
  },
  playStoreButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    backgroundColor: "#1e293b",
    borderRadius: 16,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderWidth: 1,
    borderColor: "#334155",
  },
});
